import {
    METHOD_POST,
    SERVER_URL,
    METHOD_GET,
    METHOD_PUT,
    METHOD_DELETE
} from '../constants/api';
import {
    headersAuthSendReceiveJson,
} from '../headers';
import { apiHandleResponse } from '../../util/api';

const getContractsV2 = (directoryId,isFinalized) => {
    let api = `${SERVER_URL}/api/v2/cms/contract/list?isFinalized=${isFinalized}`;
    if (directoryId !== 'root') {
        api = `${SERVER_URL}/api/v2/cms/contract/list/${directoryId}?isFinalized=${isFinalized}`
    }

    return fetch(api, {
        method: METHOD_GET,
        headers: headersAuthSendReceiveJson(),
    }).then(apiHandleResponse);
};

const getAllContractsV2 = (contractState) => {
    let api = `${SERVER_URL}/api/v2/cms/contract/list-all?contractStateName=${contractState}`;

    return fetch(api, {
        method: METHOD_GET,
        headers: headersAuthSendReceiveJson(),
    }).then(apiHandleResponse);
};

const getHeirarchy = () => {
    return fetch(`${SERVER_URL}/api/v1/cms/contract/directory/hierarchy`, {
        method: METHOD_GET,
        headers: headersAuthSendReceiveJson(),
    }).then(apiHandleResponse);
};

const createDirectory = (options) => {
    return fetch(`${SERVER_URL}/api/v1/cms/contract/directory`, {
        method: METHOD_POST,
        headers: headersAuthSendReceiveJson(),
        body: JSON.stringify(options),
    }).then(apiHandleResponse);
};
const updateDirectory = (options) => {
    return fetch(`${SERVER_URL}/api/v1/cms/contract/directory`, {
        method: METHOD_PUT,
        headers: headersAuthSendReceiveJson(),
        body: JSON.stringify(options),
    }).then(apiHandleResponse);
};

const getContractsV2DirectoryDependencies = (directoryId) => {
    return fetch(`${SERVER_URL}/api/v1/cms/contract/directory/dependencies/${directoryId}`, {
        method: METHOD_GET,
        headers: headersAuthSendReceiveJson(),
    }).then(apiHandleResponse);
};

const deleteContractsV2ScheduleDirectory = (directoryId) => {
    return fetch(`${SERVER_URL}/api/v1/cms/contract/directory/${directoryId}`, {
        method: METHOD_DELETE,
        headers: headersAuthSendReceiveJson(),
    }).then(apiHandleResponse);
};
const moveDirectoryOrContracts = (options) => {
    return fetch(`${SERVER_URL}/api/v2/cms/contractanddirectory/move`, {
        method: METHOD_POST,
        headers: headersAuthSendReceiveJson(),
        body: JSON.stringify(options),
    }).then(apiHandleResponse);
};

 
const searchContracts = (options,isSearch) => {
    return fetch(`${SERVER_URL}/api/v2/cms/contract/search${isSearch || ''}`, {
        method: METHOD_POST,
        headers: headersAuthSendReceiveJson(),
        body: JSON.stringify(options),
    }).then(apiHandleResponse);
};


const getEapgSchedules = () => {
    return fetch(`${SERVER_URL}/api/v2/cms/eapg/groupTypes`, {
        method: METHOD_GET,
        headers: headersAuthSendReceiveJson(),
    }).then(apiHandleResponse);
};



export {
    getContractsV2,
    getAllContractsV2,
    getHeirarchy,
    createDirectory,
    updateDirectory,
    getContractsV2DirectoryDependencies,
    deleteContractsV2ScheduleDirectory,
    moveDirectoryOrContracts,
    searchContracts,
    getEapgSchedules
};